import {
  PhoneAuthProvider,
  RecaptchaVerifier,
  type Auth,
  type PhoneInfoOptions,
} from "firebase/auth";

/**
 * Renders each SMS's invisible reCAPTCHA in its own child element. grecaptcha refuses to render
 * twice in one element, and clear() leaves an invisible widget in place. Reusing one verifier
 * instead leaves later sends waiting on a widget whose challenge never finished.
 */
export const verifyPhoneNumber = async (
  auth: Auth,
  recaptchaContainer: HTMLElement,
  phoneInfoOptions: PhoneInfoOptions,
) => {
  const recaptchaElement = document.createElement("div");
  recaptchaContainer.append(recaptchaElement);
  const recaptchaVerifier = new RecaptchaVerifier(auth, recaptchaElement, { size: "invisible" });
  try {
    return await new PhoneAuthProvider(auth).verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);
  } finally {
    recaptchaVerifier.clear();
    recaptchaElement.remove();
  }
};
